import { ReactNode } from 'react';
import clsx from 'clsx';
export function Tag({ children, className }: { children: ReactNode; className?: string }) {
  return <span className={clsx('inline-flex items-center h-5 px-1 hairline rounded-sm text-xs text-muted', className)}>{children}</span>;
}
